// extracted by mini-css-extract-plugin
export default {"img":"header2_img__ORThv","userimg":"header2_userimg__f6wuv","usernameIcon":"header2_usernameIcon__CQeu7","title":"header2_title__CuGCN","description":"header2_description__rrhmQ"};